import PropTypes from 'prop-types';
import { createContext, useContext, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDate } from '../../../utils/dateUtils';

const ContactsContext = createContext();

const contactsReducer = (state, action) => {
    switch (action.type) {
        /*
        case 'applicant-subtab':
            return { ...state, applicantSubTab: action.payload };

        case 'ambassador-subtab':
            return { ...state, ambassadorSubTab: action.payload };

        case 'pending-results': {
            return { ...state, pendingResults: action.payload };
        }
        case 'pending-pagination': {
            return { ...state, pendingPagination: action.payload };
        }

        case 'rejected-results': {
            return { ...state, rejectedResults: action.payload };
        }
        case 'rejected-pagination': {
            return { ...state, rejectedPagination: action.payload };
        }

        case 'prospect-results': {
            return { ...state, prospectResults: action.payload };
        }
        case 'prospect-pagination': {
            return { ...state, prospectPagination: action.payload };
        }

        case 'non-ambassador-results': {
            return { ...state, nonAmbassadorResults: action.payload };
        }
        case 'non-ambassador-pagination': {
            return { ...state, nonAmbassadorPagination: action.payload };
        }

        case 'ambassador-results': {
            return { ...state, ambassadorResults: action.payload };
        }
        case 'ambassador-pagination': {
            return { ...state, ambassadorPagination: action.payload };
        }

        case 'all-ambassador-results': {
            return { ...state, allAmbassadorResults: action.payload };
        }
        case 'all-ambassador-pagination': {
            return { ...state, allAmbassadorPagination: action.payload };
        }

        case 'reset-all-page-to-1': {
            return {
                ...state,
                ambassadorPagination: { ...state.ambassadorPagination, page: 1 },
                nonAmbassadorPagination: { ...state.nonAmbassadorPagination, page: 1 },
                allAmbassadorPagination: { ...state.allAmbassadorPagination, page: 1 },
            };
        }

        case 'group-results': {
            return { ...state, groupResults: action.payload };
        }
        case 'group-pagination': {
            return { ...state, groupPagination: action.payload };
        }
        */
        case 'store-url': {
            return { ...state, storeUrl: action.payload };
        }
        case 'filters': {
            return {
                ...state,
                // ambassadorPagination: { ...state.ambassadorPagination, page: 1 },
                // nonAmbassadorPagination: { ...state.nonAmbassadorPagination, page: 1 },
                // allAmbassadorPagination: { ...state.allAmbassadorPagination, page: 1 },
                // pendingPagination: { ...state.pendingPagination, page: 1 },
                // rejectedPagination: { ...state.rejectedPagination, page: 1 },
                // prospectPagination: { ...state.prospectPagination, page: 1 },
                // groupPagination: { ...state.groupPagination, page: 1 },
                filters: action.payload,
            };
        }
        case 'all-custom-views': {
            const {
                ambassadorTab,
                nonAmbassadorTab,
                allAmbassadorTab,
                pendingTab,
                rejectedTab,
                groupTab,
            } = action.payload;
            return {
                ...state,
                ambassadorCustomView: ambassadorTab || state.ambassadorCustomView,
                nonAmbassadorCustomView: nonAmbassadorTab || state.nonAmbassadorCustomView,
                allAmbassadorCustomView: allAmbassadorTab || state.allAmbassadorCustomView,
                pendingCustomView: pendingTab || state.pendingCustomView,
                rejectedCustomView: rejectedTab || state.rejectedCustomView,
                groupCustomView: groupTab || state.groupCustomView,
            };
        }
        case 'domain-options': {
            return {
                ...state,
                domainOptions: [...action.payload],
            };
        }
        default: {
            if (action.type.includes('CustomView')) {
                return { ...state, [action.type]: action.payload };
            }
            return state;
        }
    }
};

const ContactsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(contactsReducer, {
        /*
        applicantSubTab: null,
        ambassadorSubTab: null,
        pendingResults: { count: 0, rows: [] },
        pendingPagination: {
            sortBy: 'ambassador.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 5,
        },
        domainOptions: [],

        rejectedResults: { count: 0, rows: [] },
        rejectedPagination: {
            sortBy: 'ambassador.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 5,
        },

        prospectResults: { count: 0, rows: [] },
        prospectPagination: {
            sortBy: 'ambassador.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 100,
        },

        nonAmbassadorResults: { count: 0, rows: [] },
        nonAmbassadorPagination: {
            sortBy: 'ambassador.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 100,
        },

        ambassadorResults: { count: 0, rows: [] },
        ambassadorPagination: {
            sortBy: 'ambassador.approvedDate',
            dir: 'desc',
            page: 1,
            limit: 100,
        },

        allAmbassadorResults: { count: 0, rows: [] },
        allAmbassadorPagination: {
            sortBy: 'ambassador.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 100,
        },

        groupResults: { count: 0, rows: [] },
        groupPagination: {
            sortBy: 'group.updatedAt',
            dir: 'desc',
            page: 1,
            limit: 100,
        },
        */

        domainOptions: [],
        storeUrl: '',
        ambassadorCustomView: [
            { id: 0, key: 'GROUP_IDS', name: 'Groups', show: true },
            { id: 1, key: 'APPROVED_DATE', name: 'Approved Date', show: true },
            { id: 2, key: 'TOTAL_REACH', name: 'Total Reach', show: true },
            { id: 3, key: 'SOCIALS', name: 'Socials', show: true },
            { id: 4, key: 'REFERRAL_LINK', name: 'Referral Link', show: true },
            { id: 5, key: 'DISCOUNT_CODE', name: 'Discount Code', show: false },
            { id: 6, key: 'PAYMENT', name: 'Payment Details', show: true },
            { id: 7, key: 'TAX_DETAILS', name: 'Tax', show: true },
            { id: 8, key: 'TOTAL_SALES', name: 'Total Sales', show: true },
            { id: 9, key: 'LAST_LOGGED_IN', name: 'Last Logged In', show: false },
            { id: 10, key: 'CAMPAIGN', name: 'Campaign', show: false },
            { id: 11, key: 'CAMPAIGN_OPT_INS', name: 'Campaign Opt-Ins', show: false },
            { id: 12, key: 'TAGS', name: 'Tags', show: false },
            { id: 13, key: 'COMMISSION_TEMPLATE', name: 'Commission Template', show: false },
            { id: 14, key: 'LOCATION', name: 'Location', show: false },
        ],
        nonAmbassadorCustomView: [
            { id: 0, key: 'GROUP_IDS', name: 'Groups', show: true },
            { id: 1, key: 'APPROVED_DATE', name: 'Added Date', show: true },
            { id: 2, key: 'TOTAL_REACH', name: 'Total Reach', show: true },
            { id: 3, key: 'SOCIALS', name: 'Socials', show: true },
            { id: 4, key: 'REFERRAL_LINK', name: 'Referral Link', show: true },
            { id: 5, key: 'DISCOUNT_CODE', name: 'Discount Code', show: false },
            { id: 6, key: 'PAYMENT', name: 'Payment Details', show: true },
            { id: 7, key: 'TAX_DETAILS', name: 'Tax', show: true },
            { id: 8, key: 'TOTAL_SALES', name: 'Total Sales', show: true },
            { id: 9, key: 'CAMPAIGN', name: 'Campaign', show: false },
            { id: 10, key: 'CAMPAIGN_OPT_INS', name: 'Campaign Opt-Ins', show: false },
            { id: 11, key: 'TAGS', name: 'Tags', show: false },
            { id: 12, key: 'COMMISSION_TEMPLATE', name: 'Commission Template', show: false },
            { id: 13, key: 'LOCATION', name: 'Location', show: false },
        ],
        allAmbassadorCustomView: [
            { id: 0, key: 'GROUP_IDS', name: 'Groups', show: true },
            // Not bitwise filterable by contact type, we have views for that
            { id: 1, key: undefined, name: 'Contact Type', show: true },
            { id: 2, key: 'APPROVED_DATE', name: 'Date', show: true },
            { id: 3, key: 'TOTAL_REACH', name: 'Total Reach', show: true },
            { id: 4, key: 'SOCIALS', name: 'Socials', show: true },
            { id: 5, key: 'REFERRAL_LINK', name: 'Referral Link', show: true },
            { id: 6, key: 'DISCOUNT_CODE', name: 'Discount Code', show: false },
            { id: 7, key: 'PAYMENT_DETAILS', name: 'Payment Details', show: true },
            { id: 8, key: 'TAX_DETAILS', name: 'Tax', show: true },
            { id: 9, key: 'TOTAL_SALES', name: 'Total Sales', show: true },
            { id: 10, key: 'LAST_LOGGED_IN', name: 'Last Logged In', show: false },
            { id: 11, key: 'CAMPAIGN', name: 'Campaign', show: false },
            { id: 12, key: 'CAMPAIGN_OPT_INS', name: 'Campaign Opt-Ins', show: false },
            { id: 13, key: 'TAGS', name: 'Tags', show: false },
            { id: 14, key: 'COMMISSION_TEMPLATE', name: 'Commission Template', show: false },
            { id: 15, key: 'LOCATION', name: 'Location', show: false },
        ],
        pendingCustomView: [
            { id: 0, key: '', name: 'Age', show: true },
            { id: 1, key: '', name: 'Gender', show: true },
            { id: 2, key: '', name: 'Location', show: true },
            { id: 3, key: '', name: 'Date Applied', show: true },
            { id: 4, key: '', name: 'Total Reach', show: true },
            { id: 5, key: '', name: 'Socials', show: true },
            { id: 6, key: '', name: 'Tags', show: true },
            { id: 7, key: '', name: 'Q&A Completed', show: true },
        ],
        rejectedCustomView: [
            { id: 0, key: '', name: 'Age', show: true },
            { id: 1, key: '', name: 'Gender', show: true },
            { id: 2, key: '', name: 'Location', show: true },
            { id: 3, key: '', name: 'Date Rejected', show: true },
            { id: 4, key: '', name: 'Total Reach', show: true },
            { id: 5, key: '', name: 'Socials', show: true },
            { id: 6, key: '', name: 'Tags', show: false },
            { id: 7, key: '', name: 'Q&A Completed', show: true },
        ],
        groupCustomView: [
            { id: 0, key: '', name: 'Display Name', show: false },
            { id: 1, key: '', name: 'Date Created', show: true },
            { id: 2, key: '', name: '# of People', show: true },
            { id: 3, key: '', name: 'Total Sales', show: true },
            { id: 4, key: '', name: 'Last Edited', show: true },
        ],
        recommendedContactCustomView: [
            { id: 0, key: '', name: 'IG Handle', show: true },
            { id: 1, key: '', name: 'Reach', show: true },
            { id: 2, key: '', name: 'Topics', show: true },
            { id: 3, key: '', name: 'Hits', show: true },
            { id: 4, key: '', name: 'Found', show: true },
            { id: 5, key: '', name: 'Language', show: true },
            { id: 6, key: '', name: 'Data source', show: true },
        ],
        filters: {
            age: { min: 0, max: 0, custom: [] },
            reach: { min: 0, max: 0, custom: [] },
            socials: [],
            group: [],
            payment: [],
            tax: [],
            sales: { min: 0, max: 0 },
            numberOfPeople: { min: 0, max: 0 },
            referralLink: [],
            discountCode: [],
            date: { startDate: null, endDate: null },
            dateCreated: { startDate: null, endDate: null },
            lastLoggedIn: { startDate: null, endDate: null },
            totalSalesDateRange: { startDate: null, endDate: null },
            gender: '',
            location: [],
            foundDate: { startDate: getDate().subtract(30, 'days'), endDate: getDate() },
            language: [],
            addedDate: { startDate: null, endDate: null },
            country: [],
            engRate: { min: 0, max: 0, custom: [] },
        },
    });
    const contacts = useSelector((st) => st.contacts);
    const reduxDispatch = useDispatch();
    const value = { state: { ...state, ...contacts }, dispatch, reduxDispatch };

    return <ContactsContext.Provider value={value}>{children}</ContactsContext.Provider>;
};

ContactsProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

const useContacts = () => {
    const context = useContext(ContactsContext);
    if (context === undefined) {
        throw new Error('useContacts must be used within a ContactsProvider');
    }
    return context;
};

export { ContactsProvider, useContacts };
